













import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import AsiTextField from "@/components/common/AsiTextField";
import AsiRadioGroup from "@/components/common/AsiRadioGroup";
import {AxiosError} from "axios";
import AsiTextarea from "@/components/common/AsiTextarea";
import UserUpdate from "@/models/user/UserUpdate";
import User from "@/models/user/User";

@Component({
	components: {AsiTextarea, AsiRadioGroup, AsiTextField, AsiDialogFormLayout}
})
export default class UserUpdateDialogAdditionalInfos extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public user!: User;

	private model: UserUpdate | null = null;

	public created(): void {
		this.setUserInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setUserInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('user', {deep: true})
	private onUserChanged(): void {
		this.setUserInternal();
	}

	private setUserInternal(): void {
		if (this.model === null) {
			this.model = new UserUpdate(this.user);
		} else {
			this.model.setDetailModel(this.user);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null) return;

		this.loading = true;
		this.$userService.update(this.user.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
